import { convertDateToYearMonth, initSearch } from './dashboard';
import { dateEndOfTrimestre, dateEndOfWeek, dateStartOfTrimestre, dateStartOfWeek, formatDate, } from './utils/utils';
import { getOriginalUser } from './utilisateur';
var TYPES = {
    KANBAN: 'kanban',
    DASHBOARD: 'dashboard',
    STATISTIQUE: 'statistique',
};
var getParams = function (type, functionInit) {
    try {
        var params = localStorage.getItem("".concat(type, "-").concat(process.env.REACT_APP_NAME));
        if (!params) {
            return functionInit();
        }
        return JSON.parse(params);
    }
    catch (e) {
        return functionInit();
    }
};
var saveParams = function (type, params) {
    try {
        localStorage.setItem("".concat(type, "-").concat(process.env.REACT_APP_NAME), JSON.stringify(params));
    }
    catch (e) {
        localStorage.removeItem("".concat(type, "-").concat(process.env.REACT_APP_NAME));
    }
};
export function getParamsDashboard() {
    return getParams(TYPES.DASHBOARD, initSearch);
}
export function updateParamsDashboard(params) {
    saveParams(TYPES.DASHBOARD, params);
}
export function getParamsKanban(type) {
    var initKanban;
    switch (type) {
        case 'date': {
            initKanban = function () {
                var originalUser = getOriginalUser();
                return {
                    CollaborateurIds: originalUser.CollaborateurDefaultId
                        ? [originalUser.CollaborateurDefaultId]
                        : [],
                    GroupeId: null,
                    Debut: formatDate(dateStartOfWeek()),
                    Fin: formatDate(dateEndOfWeek()),
                    TagId: null,
                };
            };
            break;
        }
        case 'signature': {
            initKanban = function () {
                var originalUser = getOriginalUser();
                return {
                    CollaborateurIds: originalUser.CollaborateurDefaultId
                        ? [originalUser.CollaborateurDefaultId]
                        : [],
                    GroupeId: null,
                    Debut: convertDateToYearMonth(dateStartOfTrimestre()),
                    Fin: convertDateToYearMonth(dateEndOfTrimestre()),
                    TagId: null,
                };
            };
            break;
        }
        default: {
            initKanban = initSearch;
        }
    }
    var paramsKanban = getParams("".concat(TYPES.KANBAN, "-").concat(type), initKanban);
    if (type === 'date' && (!paramsKanban.Debut || !paramsKanban.Fin)) {
        return initKanban();
    }
    return paramsKanban;
}
export function updateParamsKanban(type, params) {
    saveParams("".concat(TYPES.KANBAN, "-").concat(type), params);
}
export function getParamsStatistique() {
    return getParams(TYPES.STATISTIQUE, initSearch);
}
export function updateParamsStatistique(params) {
    saveParams(TYPES.STATISTIQUE, params);
}
//# sourceMappingURL=filtre.js.map